const PRODUCT_IMG =
  'https://customer-assets-jt897jd0.emergentagent.net/job_582314cb-e0d4-4f3b-95a4-147554a5a708/artifacts/3y07x1gj_aee2706b-9652-4a2b-8c52-5c06900c5667.png';
const COMPONENTS_IMG =
  'https://customer-assets.emergentagent.com/job_582314cb-e0d4-4f3b-95a4-147554a5a708/artifacts/und2cyfg_PHOTO-2026-06-29-20-46-15.jpg';

const roboDressel = {
  slug: 'robo-dressel',
  name: 'Robo Dressel',
  testid: 'dressel',
  accent: 'emerald',
  breadcrumb: { label: 'Pool Cleaning Robots', href: '/pool-cleaning-robots' },
  brochureUrl:
    'https://customer-assets.emergentagent.com/job_582314cb-e0d4-4f3b-95a4-147554a5a708/artifacts/36zgdq1a_Robo%20Dressel_%20Swimming%20Pool%20Cleaning%20Robot.pdf',
  meta: {
    title: 'Robo Dressel - Swimming Pool Cleaning Robot | Harpalyk',
    description:
      "Robo Dressel: India's first & one of the most powerful pool cleaning robots. Triple-motor system, smart Z-navigation, wall & waterline climbing, 20µm filtration and a 30m tangle-free cable. Cleans up to 1,800 m².",
    keywords:
      'Robo Dressel, pool cleaning robot, automatic pool cleaner India, robotic pool cleaner, swimming pool robot, Harpalyk pool robot, commercial pool cleaner',
    canonical: 'https://harpalyk.com/products/robo-dressel',
  },
  schema: {
    name: 'Harpalyk Robo Dressel Swimming Pool Cleaning Robot',
    description:
      "India's first and one of the most powerful pool cleaning robots. Triple-motor system, smart Z-pattern navigation, wall & waterline climbing, 20µm ultra-fine filtration and a 30m tangle-free floating cable. Cleans up to 1,800 m².",
    image: PRODUCT_IMG,
    category: 'Robotic Pool Cleaner',
    price: '289990',
    ratingValue: '4.8',
    reviewCount: '92',
  },
  hero: {
    gradient: 'from-slate-900 via-cyan-900 to-emerald-900',
    badge: "POOLBOT · India's First & Most Powerful Pool Cleaning Robot",
    tagline: 'Smart. Powerful. Reliable.',
    description:
      'A complete pool cleaning solution with unbeatable value. Designed for the extra demands of large pools — combining advanced navigation, powerful suction and ultra-fine filtration for crystal-clear water.',
    highlights: [
      { label: '1,800 m² Coverage', icon: 'Maximize2' },
      { label: 'Wall & Waterline Clean', icon: 'Waves' },
      { label: '30m Tangle-Free Cable', icon: 'Navigation' },
      { label: '20µm Ultra Filtration', icon: 'Filter' },
    ],
    galleryAccent: 'emerald',
    galleryBadge: 'Pro Pool Robot',
  },
  overview: {
    heading: 'Intelligent Cleaning. Effortless Performance.',
    sub: 'The Robo Dressel is specifically designed to cope with the extra demands of large pools, delivering a thorough clean for better water quality while saving water, time and effort — no draining required.',
    checklistTitle: 'A Complete Cleaning Solution',
    checklist: [
      'Powerful twin-drive motors for exceptional maneuverability & climbing',
      'Dedicated water pump filters over 300 litres per minute',
      '2 large intake gates + high-capacity filter for a deep, thorough clean',
      'Cleans floor, walls, stairs, coves and the waterline',
      'Suitable for all pool shapes, types and surfaces',
      'Saves up to 94% energy and 40% pool chemicals',
      'Reliable, durable performance built to last year after year',
    ],
    panelGradient: 'from-emerald-50 to-cyan-50',
    stats: [
      { value: '1,800 m²', label: 'Max Coverage' },
      { value: '180 cm', label: 'Wall Climb' },
      { value: '20 µm', label: 'Filtration' },
      { value: '30 m', label: 'Floating Cable' },
      { value: '200 W', label: 'Rated Power' },
      { value: '94%', label: 'Energy Saved' },
    ],
  },
  features: {
    heading: 'Powerful Features for a Spotless Pool',
    items: [
      { icon: 'Cpu', title: 'Triple-Motor System', description: '3 high-performance motors with twin-drive technology deliver superior scrubbing force and enhanced suction.' },
      { icon: 'Navigation', title: 'Smart Z-Navigation', description: 'Intelligent path-planning algorithm ensures systematic, complete pool coverage with optimized cleaning routes.' },
      { icon: 'Waves', title: 'Wall & Waterline Climbing', description: 'Powerful traction cleans floors, walls, steps, coves and the waterline — climbs walls up to 180 cm high.' },
      { icon: 'Filter', title: '20µm Ultra-Fine Filtration', description: 'Multi-stage filtration captures leaves, dirt, hair, algae and fine particles down to 20 microns.' },
      { icon: 'Maximize2', title: '30m Tangle-Free Cable', description: 'Extended-reach floating cable with anti-twist design for uninterrupted cleaning of large pools.' },
      { icon: 'Shield', title: 'IP68 Waterproof', description: 'Fully sealed underwater protection (IP68 robot, IP26 control box) for safe, reliable operation.' },
      { icon: 'Smartphone', title: 'Full-Function Remote', description: 'Handheld remote enables manual navigation, target cleaning of problem areas and custom cycle settings.' },
      { icon: 'Sparkles', title: 'Robotic 6th Sense', description: 'Multiple onboard sensors monitor position, movement and conditions for intelligent, hands-off cleaning.' },
      { icon: 'Zap', title: 'Powerful Suction & Pumping', description: 'Dedicated water-pump system delivers a filtration rate of over 20,000 litres per hour.' },
      { icon: 'Battery', title: 'Energy & Chemical Savings', description: 'Saves up to 94% energy and reduces pool chemical consumption by up to 40% — no water drainage needed.' },
    ],
  },
  sections: [
    {
      type: 'split',
      label: 'Navigation Technology',
      heading: 'Smart Z-Pattern Navigation',
      desc: 'Advanced path-planning technology creates optimized cleaning patterns that maximize coverage while reducing cleaning time, with real-time obstacle detection and 360° directional mobility.',
      itemIcon: 'Navigation',
      items: [
        { title: 'Intelligent Path Planning', desc: 'Systematic Z-shape floor and cross-pattern cleaning for complete coverage' },
        { title: '360° Directional Mobility', desc: 'Seamless movement with real-time obstacle detection & avoidance' },
        { title: 'Robotic 6th Sense', desc: 'Onboard sensors monitor position, movement and operating conditions' },
        { title: 'Wall, Stair & Waterline Climbing', desc: 'Climbs and scrubs walls up to 180 cm high with precision' },
      ],
      panel: {
        gradient: 'from-cyan-600 to-emerald-700',
        title: 'Built for Large Pools',
        desc: 'With a 30m tangle-free floating cable and intelligent navigation, the Robo Dressel covers up to 1,800 m² efficiently — perfect for residential and commercial swimming pools.',
        subClass: 'text-cyan-100',
        statClass: 'text-emerald-300',
        stats: [
          { value: '1,800', label: 'm² Coverage' },
          { value: '30m', label: 'Floating Cable' },
        ],
      },
    },
    {
      type: 'darkCards',
      label: 'Cleaning Performance',
      heading: 'Amazing Cleaning Power',
      sub: 'Triple-motor power, dedicated water-pump filtration and ultra-fine filter bags deliver a deep, thorough clean for noticeably better water quality.',
      cards: [
        { icon: 'Zap', title: 'Triple-Motor Suction', desc: 'Twin drive motors plus a dedicated water pump and four heavy-duty scrubbing wheels generate ultra-strong suction and traction across the entire pool.', badge: '3 Motors • 200W' },
        { icon: 'Filter', title: 'Multi-Stage Filtration', desc: 'Filters over 20,000 L/hour and captures leaves, dirt, hair, algae and fine particles down to 20 microns with reusable, washable eco-friendly filter bags.', badge: 'Down to 20µm' },
        { icon: 'Waves', title: 'Complete Coverage', desc: 'Cleans the floor, walls, stairs, coves and waterline — climbing walls up to 180 cm — for a truly comprehensive clean on any pool shape or surface.', badge: 'Floor • Walls • Waterline' },
      ],
    },
    {
      type: 'listGroups',
      label: 'Versatility',
      heading: 'Suitable for All Pool Shapes, Types & Surfaces',
      groups: [
        { title: 'Pool Types', items: ['Above-Ground Pools', 'In-Ground Pools', 'Residential Pools', 'Commercial Pools'] },
        { title: 'Pool Surfaces', items: ['Tile (Large & Small)', 'Vinyl', 'Gunite', 'Fiberglass'] },
        { title: 'Pool Shapes', items: ['Rectangular', 'Round', 'Oval', 'Kidney', 'L-Shaped', 'Freeform', 'Lap Pools'] },
      ],
    },
    {
      type: 'imageSplit',
      bg: 'gray',
      image: COMPONENTS_IMG,
      imageAlt: 'Robo Dressel components - main robot, control box, control panel, 30m cable and remote controller',
      label: "What's in the Box",
      heading: 'A Complete, Ready-to-Clean System',
      items: [
        { title: 'Main Robot', desc: 'Engineered for excellence with deep-cleaning brushes and four-wheel drive' },
        { title: 'Smart Control Box', desc: 'Sleek IP26 power unit with 1H / 2H / 4H timers and climb/power controls' },
        { title: '30M Floating Cable', desc: 'Extra long, tangle-free cable for maximum coverage' },
        { title: 'Ergonomic Remote Controller', desc: 'Intuitive handheld remote for effortless target cleaning' },
      ],
    },
    {
      type: 'duoPanels',
      panels: [
        {
          theme: 'blue',
          icon: 'Shield',
          title: 'Advanced Safety & Self-Protection',
          desc: 'Smart sensors and a safe 29V DC low-voltage system keep the Robo Dressel protected and reliable throughout every cleaning cycle.',
          listIcon: 'RotateCcw',
          list: [
            'Rights itself automatically when inverted',
            'Automatically shuts down at the end of the cleaning cycle',
            'Impeller stops if obstructed by large foreign objects',
            'Impeller stops within 1 second when removed from water',
            'Automatically reverses and re-enters the water at beach entries',
          ],
        },
        {
          theme: 'emerald',
          icon: 'Droplets',
          title: 'Economical & Eco-Friendly',
          desc: 'The Robo Dressel cleans efficiently while protecting your pocket and the planet — with no water drainage required after cleaning.',
          rows: [
            { icon: 'Battery', pre: 'Up to ', bold: '94% energy savings', post: '' },
            { icon: 'Droplets', pre: 'Up to ', bold: '40% less chemicals', post: '' },
            { icon: 'Timer', pre: '', bold: 'No draining', post: ' required after cleaning' },
          ],
        },
      ],
    },
  ],
  specs: {
    defaultTab: 'general',
    tabs: [
      { id: 'general', label: 'General' },
      { id: 'performance', label: 'Performance' },
      { id: 'filtration', label: 'Filtration & Drive' },
      { id: 'control', label: 'Control & Safety' },
    ],
    data: {
      general: [
        { label: 'Model Name', value: 'Robo-Dressel' },
        { label: 'Material', value: 'High-Grade ABS Plastic' },
        { label: 'Color', value: 'Light Blue' },
        { label: 'Input Voltage', value: '100-220V AC' },
        { label: 'Rated Power', value: '200 W' },
        { label: 'Waterproof Rating', value: 'IP68 Robot / IP26 Box' },
        { label: 'Dimensions (L×W×H)', value: '456 × 462 × 280 mm' },
        { label: 'Gross Weight', value: '20 kg' },
      ],
      performance: [
        { label: 'Max Cleaning Area', value: 'Up to 1,800 m²' },
        { label: 'Cleaning Speed', value: '70-80 m²/hour' },
        { label: 'Moving Speed', value: '15 m/min' },
        { label: 'Water Filtration Rate', value: '20,000 L/hour' },
        { label: 'Wall Climbing Height', value: 'Up to 180 cm' },
        { label: 'Cleaning Coverage', value: 'Floor, Walls, Waterline, Stairs' },
      ],
      filtration: [
        { label: 'Standard Filter Bag', value: '70 µm Fine Filtration' },
        { label: 'Optional Fine Filter', value: '20 µm Ultra-Fine' },
        { label: 'Drive System', value: 'Twin Drive Motor' },
        { label: 'Motors', value: '3 High-Performance Motors' },
        { label: 'Scrubbing System', value: '4 Heavy-Duty Wheels' },
        { label: 'Cable Length', value: '30 m Floating Cable' },
      ],
      control: [
        { label: 'Control Method', value: 'Automatic / Remote' },
        { label: 'Cleaning Modes', value: 'Floor / Wall & Floor' },
        { label: 'Cycle Time Options', value: '1 / 2 / 4 Hours' },
        { label: 'Timer Settings', value: '3 Programmable Schedules' },
        { label: 'Auto Shut-Off', value: 'Yes' },
        { label: 'Low-Voltage Operation', value: '29V DC Safe System' },
      ],
    },
  },
  contact: {
    heading: 'Ready for a Crystal-Clear Pool?',
    sub: 'Upgrade to effortless, professional pool cleaning with the Robo Dressel. Contact us today for pricing and availability.',
    gradient: 'from-emerald-600 to-cyan-700',
  },
  faqs: [
    {
      question: 'Which pool types and surfaces does the Robo Dressel work with?',
      answer:
        'The Robo Dressel is suitable for all pool shapes, types and surfaces. It works in above-ground, in-ground, residential and commercial pools — including rectangular, round, oval, kidney, L-shaped, freeform and lap pools — and is compatible with tile, vinyl, gunite and fiberglass surfaces.',
    },
    {
      question: 'How does it clean walls and the waterline?',
      answer:
        'A powerful traction system combined with twin-drive motors lets the Robo Dressel climb and scrub walls up to 180 cm high, cleaning the floor, walls, stairs, coves and waterline. Smart Z-pattern navigation ensures systematic, complete coverage of the entire pool.',
    },
    {
      question: 'What can the filtration system capture?',
      answer:
        'A dedicated water pump filters over 20,000 litres per hour through a high-capacity multi-stage system. The standard 70µm bag captures leaves, dirt, hair and algae, while the optional 20µm ultra-fine filter captures contaminants down to 20 microns. All filter bags are reusable, washable and eco-friendly.',
    },
    {
      question: 'How much energy and chemicals does it save?',
      answer:
        'The Robo Dressel saves up to 94% energy compared to traditional pool cleaning systems and reduces pool chemical consumption by up to 40%. It also requires no water drainage after cleaning, saving water, time and effort.',
    },
    {
      question: 'Is it safe and easy to operate?',
      answer:
        'Yes. It runs on a safe 29V DC low-voltage system with integrated overload protection. It can be run fully automatically or via the full-function handheld remote. Built-in safety features include auto shut-off, inversion recovery, impeller protection and automatic re-entry at beach-entry pools.',
    },
  ],
  related: [
    { label: 'All Pool Robots', href: '/pool-cleaning-robots' },
    { label: 'HygienX 300', href: '/products/hygienx-300' },
    { label: 'Window Cleaning Robots', href: '/window-cleaning-robots' },
    { label: 'Robotic Lawn Mowers', href: '/robotic-lawn-mowers' },
    { label: 'View All Products', href: '/#products' },
  ],
};

export default roboDressel;
